import { type ActiveIntegration } from '../types'
import { isANeedsAttentionIntegrationStatus } from './integration-status'

export type ActiveIntegrationsPill = 'All' | 'Needs Attention'

export type ActiveIntegrationsFilterParams = {
	searchValue: string | null,
	filterValues: string[],
	pillValue: ActiveIntegrationsPill,
}

export type VisibleActiveIntegrations = {
	visibleIntegrations: ActiveIntegration[],
	allCount: number,
	needsAttentionCount: number,
}

export const getVisibleActiveIntegrations = (
	integrations: ActiveIntegration[],
	{ searchValue, filterValues, pillValue }: ActiveIntegrationsFilterParams,
): VisibleActiveIntegrations => {
	const searched = searchValue
		? integrations.filter( ( integration ) => {
			const searchLowerCase = searchValue.toLowerCase()
			const integrationNameLowerCase = integration.integration?.name?.toLowerCase()
			return (
				integration.name.toLowerCase().includes( searchLowerCase ) ||
				( integrationNameLowerCase?.includes( searchLowerCase ) ?? false )
			)
		} )
		: integrations

	const filtered = filterValues.length
		? searched.filter( ( integration ) => filterValues.includes( integration.integration?.name?.toLowerCase() ?? '' ) )
		: searched

	const needsAttention = filtered.filter( ( integration ) => isANeedsAttentionIntegrationStatus( integration.currentStatus ) )

	const visibleIntegrations = pillValue === 'Needs Attention' ? needsAttention : filtered

	return {
		visibleIntegrations,
		allCount: filtered.length,
		needsAttentionCount: needsAttention.length,
	}
}
